import { QueryTuple, useLazyQuery } from '@apollo/client';
import { CrewProgressStatsInput, CrewProgressStatsList, PagingInput } from '@bechtel/types';
import { GET_CREW_PROGRESS_STATS } from '@bechtel/client-gql';

export function useCrewProgressStatsQuery(
  fetchFromNetwork?: boolean
): QueryTuple<{ crewProgressStats: CrewProgressStatsList }, { input: CrewProgressStatsInput; paging: PagingInput }> {
  const response = useLazyQuery<
    { crewProgressStats: CrewProgressStatsList },
    { input: CrewProgressStatsInput; paging: PagingInput }
  >(
    GET_CREW_PROGRESS_STATS,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
